// TODO replace models with interfaces
import CartOptionModel from "@Model/CartOptionModel";
import BundleModel from "@Model/BundleModel";
import FreeChoiceSetModel from "@Model/FreeChoiceSetModel";
import DiscountModel from "@Model/DiscountModel";
import OfferModel from "@Model/loyalty/OfferModel";
import ItemPriceModel from "@Model/ItemPriceModel";
import { forEach, filter, concat, compact, cloneDeep, flattenDeep, flatMap, includes, reduce, map, find, } from 'lodash';
var CartItemModel = /** @class */ (function () {
    function CartItemModel(data) {
        this.id = data.id;
        this.name = data.name;
        this.image = data.image;
        this.price = +(data.price);
        this.basePrice = +(data.basePrice || 0);
        this.quantity = data.quantity || 1;
        this.options = [];
        if (data.options) {
            this.options = map(data.options, function (option) {
                if (option['__mc'] === 'CartOptionModel') {
                    return new CartOptionModel(option);
                }
                return option;
                // add option is used to quickly restore options
                // from recent scripts
                // const cartOption = new CartOptionModel(option);
                // this.addOption(cartOption);
            });
        }
        this.siblings = data.siblings || [];
        this.categoryId = data.categoryId;
        this.bundle = null;
        if (data.bundle) {
            this.bundle = new BundleModel(data.bundle);
            if (this.bundle.items) { // only appears on populated cart items
                this.bundle.items = map(this.bundle.items, function (item) {
                    if (item['__mc'] === 'CartItemModel') {
                        return new CartItemModel(item);
                    }
                    return item;
                });
            }
        }
        this.discounts = [];
        if (data.discounts) {
            this.discounts = map(data.discounts, function (discount) {
                if (discount.codeName && !data.bundle) {
                    return null;
                }
                if (discount['__mc'] === "OfferModel") {
                    return new OfferModel(discount);
                }
                if (discount['__mc'] === "DiscountModel") {
                    return new DiscountModel(discount);
                }
                return discount;
            });
        }
        this.discounts = compact(this.discounts);
        this.referenceIds = null;
        this.freeChoices = null;
        if (data.freeChoices) {
            var freeChoices = data.freeChoices;
            if (freeChoices['__mc'] === "FreeChoiceSetModel") {
                this.freeChoices = new FreeChoiceSetModel(freeChoices);
            }
        }
        this.couponCode = data.couponCode || '';
        this.parentGroupId = data.parentGroupId || 0;
        this.parentAssetId = data.parentAssetId || null;
        this.inBundle = null;
        this.bundleDisplayPrice = data.bundleDisplayPrice || 0;
        this.cachedPrice = null;
        this.cachedOptions = null;
        this.index = null;
        this.hasExceptions = data.hasExceptions || false;
        this.__mc = 'CartItemModel';
    }
    CartItemModel.prototype.addOption = function (option) {
        this.options.push(option);
    };
    CartItemModel.prototype.invalidatePriceCache = function () {
        this.cachedOptions = null;
        this.cachedPrice = null;
    };
    CartItemModel.prototype.setQuantity = function (quantity) {
        this.quantity = quantity;
        this.invalidatePriceCache();
    };
    CartItemModel.prototype.setGroupId = function (groupId) {
        this.parentGroupId = groupId;
    };
    // discount could be an OfferModel or DiscountModel export
    CartItemModel.prototype.addDiscount = function (discount) {
        var discounts = this.discounts;
        if (!discounts) {
            this.discounts = [];
        }
        // before pushing make sure we don't already have this discount
        if (discount.maxRedemptions === 1) {
            this.removeDiscount(discount);
        }
        this.discounts.push(discount);
    };
    // TODO rename this method: remove discount doesn't make sense without context
    CartItemModel.prototype.removeDiscount = function (_discount) {
        if (this.bundle) {
            return;
        }
        if (_discount.rewardId || _discount.id) {
            var discounts = this.discounts;
            var remainingDiscounts = filter(discounts, function (discount) {
                var offerMatch = (_discount.rewardId === discount.reward_id);
                var discountMatch = (_discount.id === discount.id);
                return (!offerMatch && !discountMatch);
            });
            this.discounts = remainingDiscounts;
        }
    };
    CartItemModel.prototype.removeAllDiscounts = function () {
        if (!this.bundle) {
            this.discounts = [];
        }
    };
    CartItemModel.prototype.getDiscountTotal = function () {
        var _this = this;
        var discounts = this.discounts;
        var total = 0;
        total = reduce(discounts, function (accumulator, discount) {
            if (discount.reward_id) {
                return accumulator;
            }
            return accumulator + discount.discountPriceForItem(_this);
        }, 0);
        return total;
    };
    CartItemModel.prototype.getDiscountIds = function () {
        var discounts = this.discounts;
        var ids = flatMap(discounts, 'id');
        return ids;
    };
    CartItemModel.prototype.hasDiscount = function (discount) {
        var discountIds = this.getDiscountIds();
        return includes(discountIds, discount);
    };
    CartItemModel.prototype.hasDiscounts = function () {
        var discounts = this.discounts;
        return (discounts.length > 0);
    };
    CartItemModel.prototype.hasDiscountPerQuantity = function () {
        var discounts = this.discounts;
        var quantity = this.quantity;
        if (discounts.length === quantity) {
            return true;
        }
        return false;
    };
    CartItemModel.prototype.hasCouponDiscount = function () {
        if (!this.hasDiscounts()) {
            return;
        }
        var discounts = this.discounts;
        var couponDiscount = find(discounts, function (discount) {
            if (!discount.discount_id) {
                return false;
            }
            return discount.isCouponBased();
        });
        return couponDiscount;
    };
    CartItemModel.prototype.hasOfferDiscount = function () {
        if (!this.hasDiscounts()) {
            return;
        }
        var discounts = this.discounts;
        var offerDiscount = find(discounts, function (discount) {
            if (!discount.reward_id) {
                return false;
            }
            return true;
        });
        return offerDiscount;
    };
    CartItemModel.prototype.getUpsellDiscount = function () {
        var discounts = this.discounts;
        var upsellId = map(discounts, function (discount) {
            var match = false;
            if (typeof discount.isUpsell === 'function') {
                match = discount.isUpsell();
            }
            return match;
        });
        return upsellId;
    };
    CartItemModel.prototype.getDiscountReferencesCount = function () {
        var referenceIds = this.referenceIds;
        if (!referenceIds) {
            return 0;
        }
        return referenceIds.length;
    };
    CartItemModel.prototype.canApplyOffer = function () {
        var referencesCount = this.getDiscountReferencesCount();
        var discountTotal = this.getDiscountTotal();
        if (referencesCount >= this.quantity || discountTotal > 0) {
            return false;
        }
        return true;
    };
    CartItemModel.prototype.hasCoupon = function () {
        var discounts = this.discounts;
        var coupon = find(discounts, function (discount) {
            var couponCode = discount.codeName;
            if (couponCode && couponCode.length > 0) {
                return true;
            }
        });
        return (coupon);
    };
    CartItemModel.prototype.hash = function () {
        return JSON.stringify(this);
    };
    CartItemModel.prototype.getBasePrice = function (optionExceptions) {
        var optionsPrice = this.baseOptionsPrice(optionExceptions);
        var totalPrice = (this.price + optionsPrice);
        return totalPrice * this.quantity;
    };
    CartItemModel.prototype.baseOptionsPrice = function (optionExceptions) {
        var masterId = (optionExceptions) ? optionExceptions.id : null;
        var price = 0;
        forEach(this.options, function (option) {
            if (masterId) {
                if (option.id === masterId) {
                    option.isMaster = true;
                }
            }
            var choices = filter(option.choices, function (choice) {
                if (masterId) {
                    var parentId = choice.parentId;
                    return (parentId === masterId);
                }
                return false;
            });
            forEach(choices, function (choice) {
                price += choice.price;
            });
        });
        return price;
    };
    CartItemModel.prototype.createSiblings = function (siblingId) {
        var optionsCopy = cloneDeep(this.options);
        var sibling = cloneDeep(this);
        sibling.siblings = [];
        var hasOneChoice = false;
        var optionChoices = sibling.options.map(function (option) {
            var opt = option.siblingOptionFilter(siblingId);
            if (opt.choices.length) {
                hasOneChoice = true;
            }
            return opt;
        });
        // no optionChoices for a siblingId means no sibling
        //
        if (!hasOneChoice) {
            return;
        }
        var wholeOptions = optionsCopy.map(function (option) {
            return option.siblingOptionFilter('0');
        });
        if (siblingId !== '0') {
            for (var i = 0; i < wholeOptions.length; i++) {
                wholeOptions[i] = wholeOptions[i].combineChoices(optionChoices[i].choices);
            }
        }
        var flattenOptions = flattenDeep(wholeOptions);
        flattenOptions = flattenOptions.filter(function (option) {
            return (option.choices.length > 0);
        });
        if (flattenOptions.length === 0) {
            return;
        }
        sibling.options = flattenOptions;
        this.siblings.push(sibling);
    };
    CartItemModel.prototype.invertSiblings = function () {
        var options = this.options;
        options = forEach(options, function (option) {
            option.choices = forEach(option.choices, function (choice) {
                if (choice.includedQuantity === choice.quantity) {
                    choice.userSet = false;
                }
            });
        });
        forEach(options, function (option) {
            var choiceChanges = [];
            var invertSiblingChoices = filter(option.choices, function (choice) {
                // find included option choice
                return (choice.siblingId !== '0');
            });
            invertSiblingChoices.forEach(function (choice) {
                //clone choice and negate
                var clonedChoice = cloneDeep(choice);
                clonedChoice.siblingId = (clonedChoice.siblingId === '1') ? '2' : '1';
                clonedChoice.quantity = 0;
                clonedChoice.selected = false;
                clonedChoice.userSet = true;
                if (clonedChoice.includedQuantity !== 0) {
                    choiceChanges.push(clonedChoice);
                }
            });
            option.choices = concat(option.choices, choiceChanges);
        });
    };
    CartItemModel.prototype.removeDiscountFromSiblings = function (siblings) {
        forEach(siblings, function (item) {
            item.discounts = [];
        });
        return siblings;
    };
    CartItemModel.prototype.prepareItemForExport = function (base) {
        this.siblings = [];
        this.invertSiblings();
        this.createSiblings('1');
        this.createSiblings('2');
        var exportItem;
        var siblingCount = this.siblings.length;
        if (siblingCount === 0) {
            // No siblings is fine: include the item by itself
            //
            exportItem = this.exportModel(base);
        }
        else {
            // now attach subsequent siblings to first sibling
            //
            var firstSib = null;
            if (siblingCount === 1) {
                this.createSiblings('0');
                firstSib = this.siblings.pop();
            }
            else {
                firstSib = this.siblings.shift();
            }
            exportItem = firstSib.exportModel(base);
            exportItem.sibs = [];
            this.siblings.forEach(function (sibling) {
                var exportItemSib = sibling.exportModel(base);
                exportItem.sibs.push(exportItemSib);
            });
            exportItem.sibs = this.removeDiscountFromSiblings(exportItem.sibs);
        }
        return exportItem;
    };
    CartItemModel.prototype.getPriceModel = function (_options) {
        var options = _options || this.options;
        if (!this.priceModel) {
            this.priceModel = new ItemPriceModel({
                options: options,
                freeChoices: this.freeChoices,
                itemHasExceptions: this.hasExceptions,
            });
        }
        else {
            this.priceModel.options = options;
            this.priceModel.initializeTotals();
        }
        return this.priceModel;
    };
    CartItemModel.prototype.getTotalsFlyweight = function (_options) {
        var priceModel = this.getPriceModel(_options);
        return priceModel.totals;
    };
    CartItemModel.prototype.getSingleItemTotal = function (_options) {
        var priceModel = this.getPriceModel(_options);
        var optionTotal = priceModel.price();
        return (this.price + optionTotal);
    };
    CartItemModel.prototype.getSingleItemDisplayPrice = function () {
        var total = this.getSingleItemTotal();
        var hasBundle = !!this.bundle;
        if (hasBundle) {
            total = this.bundle.getBundleTotal();
        }
        if (total === 0) {
            total = this.cachedPrice;
        }
        return total / 100;
    };
    CartItemModel.prototype.getItemTotal = function (_options) {
        var optionString = JSON.stringify(_options);
        if (optionString !== this.cachedOptions || !this.cachedPrice) {
            this.cachedOptions = JSON.stringify(_options);
            this.cachedPrice = this.getSingleItemTotal(_options) * this.quantity;
        }
        return this.cachedPrice;
    };
    CartItemModel.prototype.getChoicesForOption = function (optionId) {
        var option = find(this.options, function (option) {
            var removePrefix = option.id.replace(/f/gi, '');
            var isFranchisorId = removePrefix === optionId;
            return option.id === optionId || isFranchisorId;
        });
        return (option) ? option.choices : [];
    };
    CartItemModel.prototype.getOption = function (optionId) {
        var option = find(this.options, function (option) {
            var removePrefix = option.id.replace(/f/gi, '');
            var isFranchisorId = removePrefix === optionId;
            return option.id === optionId || isFranchisorId;
        });
        return option;
    };
    CartItemModel.prototype.getChoiceIdsForOption = function (optionId) {
        var choices = this.getChoicesForOption(optionId);
        var choiceIds = flatMap(choices, function (choice) {
            return choice.id;
        });
        return choiceIds;
    };
    CartItemModel.prototype.satisfiesException = function (exception, choices) {
        var choicesForOption = choices || this.getChoicesForOption(exception.id);
        var defaultChoices = exception.masterOption.defaultChoices;
        var itemMatches = true;
        if (exception.masterOption.allChoicesIncluded()) {
            return true;
        }
        forEach(choicesForOption, (function (choice) {
            var choiceId = choice.id + "-";
            if (defaultChoices[choiceId]) {
                // if not included, doesn't satisfy
                if (defaultChoices[choiceId] && !defaultChoices[choiceId].included) {
                    itemMatches = false;
                }
            }
        }));
        return itemMatches;
    };
    CartItemModel.prototype.getMatchingId = function (assetId) {
        var matchingId = null;
        if (assetId === this.id) {
            matchingId = this.id;
        }
        else if (assetId === this.parentAssetId) {
            matchingId = this.parentAssetId;
        }
        return matchingId;
    };
    CartItemModel.prototype.getIds = function () {
        return [
            this.id,
            this.parentAssetId,
            this.parentGroupId
        ];
    };
    CartItemModel.prototype.exportBundle = function (locationBase) {
        if (!this.bundle) {
            return null;
        }
        return this.bundle.exportModel(locationBase);
    };
    CartItemModel.prototype.exportModel = function (locationBase) {
        var _this = this;
        var exportedOptions = this.options.map(function (option) {
            return option.exportModel(_this.hasExceptions);
        });
        var exportedDiscounts = this.discounts.map(function (discount) {
            return discount.export();
        });
        var exportedReferences = map(this.referenceIds, function (referenceId) {
            if (typeof referenceId.export !== 'function') {
                return;
            }
            return referenceId.export();
        });
        exportedReferences = compact(exportedReferences);
        var basePrice = this.basePrice || this.price;
        return {
            base_price: basePrice,
            options: exportedOptions,
            asset_id: this.id,
            parent_asset_id: this.parentAssetId,
            base: locationBase,
            bundle: this.exportBundle(locationBase),
            discounts: exportedDiscounts,
            coupon_code: this.couponCode,
            reference_ids: exportedReferences,
            quantity: this.quantity,
        };
    };
    return CartItemModel;
}());
export default CartItemModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/CartItemModel.ts
// module id = YDhb
// module chunks = 18